import { render, staticRenderFns } from "./add-dish-form.vue?vue&type=template&id=5b1b33d6&"
import script from "./add-dish-form.vue?vue&type=script&lang=ts&"
export * from "./add-dish-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports